module.exports = __webpack_public_path__ + "static/media/lantern-festival.8ca19d96.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightBrowse/img/events/lantern-festival.jpeg
// module id = 1040
// module chunks = 0